import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n";
import { whatsappUrl } from "@/utils";

const FLEET_IMG =
  "https://images.unsplash.com/photo-1758804025391-c29fbd14e748?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXIlMjB3aW5kc2hpZWxkfGVufDB8fHx8MTc4NzMxOTkzMHww&ixlib=rb-4.1.0&q=85";

export const Fleet = () => {
  const { t } = useLanguage();
  return (
    <section id="fleet" className="relative py-28 sm:py-36 bg-[#F3F1EC] border-y border-black/5" data-testid="fleet-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="relative order-2 lg:order-1"
        >
          <div className="absolute -inset-3 border border-[#D4AF37]/40 translate-x-5 translate-y-5 pointer-events-none" />
          <div className="relative overflow-hidden">
            <img src={FLEET_IMG} alt="Fleet vehicles" className="w-full h-[420px] sm:h-[520px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="order-1 lg:order-2"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#D4AF37]">{t.fleet.label}</span>
          </div>
          <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl leading-[1.05]">{t.fleet.title}</h2>
          <p className="mt-6 text-black/65 text-base sm:text-lg leading-relaxed max-w-lg">{t.fleet.sub}</p>
          <ul className="mt-10 space-y-4">
            {t.fleet.bullets.map((b, i) => (
              <motion.li
                key={b}
                initial={{ opacity: 0, x: 24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="flex items-center gap-3 text-black/75"
              >
                <span className="w-6 h-6 rounded-full bg-[#D4AF37] text-black flex items-center justify-center shrink-0">
                  <Check className="w-3.5 h-3.5" />
                </span>
                <span className="font-medium">{b}</span>
              </motion.li>
            ))}
          </ul>
          <a
            href={whatsappUrl(t.whatsapp.prefill)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="fleet-cta"
            className="mt-12 inline-flex items-center gap-2 border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black font-bold px-8 py-4 rounded-full transition-colors duration-300"
          >
            {t.fleet.cta}
            <ArrowUpRight className="w-5 h-5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
